import CardTableArusKas from "components/Cards/CardTableArusKas";
import React from "react";
import { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { getDropdownTahunValue } from "views/admin/masterData/dataTahun/api/dataTahunAPI";
import { getDropdownUnitUsaha } from "views/admin/masterData/unitUsaha/api/unitUsahaAPI";
import { getLaporanArusKas } from "./api/arusKasAPI";

export default function ArusKas() {
  const [formData, setFormData] = useState({
    tahun: new Date().getFullYear(),
  });
  const [dataArusKas, setDataArusKas] = useState([]);
  const [detailArusKas, setDetailArusKas] = useState([]);

  // Select-Option Data
  const [dropdownTahun, setDropdownTahun] = useState([]);
  const [dropdownUnitUsaha, setDropdownUnitUsaha] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    } else {
      toast.dismiss();
    }

    return () => {
      setIsLoading(false);
    };
  }, [isLoading]);

  // Set Inputted Data to Form
  const setData = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  // Select-Option Data
  // Load Dropdown Tahun
  useEffect(() => {
    setIsLoading(true);
    getDropdownTahunValue()
      .then((response) => {
        setDropdownTahun(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getDropdownUnitUsaha()
      .then((response) => {
        setDropdownUnitUsaha(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));
  }, []);

  const handleGetLaporanArusKas = (e) => {
    e.preventDefault();
    setIsLoading(true);

    getLaporanArusKas(formData)
      .then((response) => {
        setDataArusKas(response.data.data);
        setDetailArusKas(response.data.detail);
      })
      .catch((err) => setErrors(err))
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {}, 5000);
        toast.dismiss();
      });
  };

  const handleResetFilter = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setFormData({
      tahun: new Date().getFullYear(),
    });

    getLaporanArusKas({
      tahun: new Date().getFullYear(),
    })
      .then((response) => {
        setDataArusKas(response.data.data);
        setDetailArusKas(response.data.detail);
      })
      .catch((err) => setErrors(err))
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {}, 5000);
        toast.dismiss();
      });
  };

  // Check if Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  useEffect(() => {
    getLaporanArusKas()
      .then((res) => {
        // console.log(res.data);
        setResult(res.data);
      })
      .catch((err) => {
        setErrors(err);
      })
      .finally(() => {
        setTimeout(() => {}, 5000);
        toast.dismiss();
      });
  }, []);

  useEffect(() => {
    if (result !== null) {
      setDataArusKas(result.data);
      setDetailArusKas(result.detail);
    }
  }, [result]);

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <Toaster />
          <CardTableArusKas
            tableTitle="Laporan Arus Kas"
            data={dataArusKas}
            detail={detailArusKas}
            dropdownTahun={dropdownTahun}
            dropdownUnitUsaha={dropdownUnitUsaha}
            handleSubmit={handleGetLaporanArusKas}
            resetFilter={handleResetFilter}
            setData={setData}
          />
        </div>
      </div>
    </div>
  );
}
